<template>
  <div class="containter">
    <div class="h-bg">
      <div class="header-box">
        <div class="header-box-left">
          <div class="top-time">
            <el-image style="width: 26px; height: 25px;margin-right: 9px"
                      :src="require('@/assets/images/header/dateTime.png')" fit="cover"></el-image>
            <div>
              <div class="f11">{{ nowTimeDay }}</div>
              <div class="f16" style="letter-spacing:2px">{{ nowTimeSecond }}</div>
            </div>
          </div>
        </div>
        <div class="title f40">{{currentCollege.name}}专利统计分析系统</div>
        <div class="header-box-right">
          <el-select v-model="collegeId" style="width: 160px; height: 34px; margin-left: auto" filterable  @change="setCurrentCollege">
            <el-option v-for="i in collegeList" :value="i.id" :label="i.name" :key="i.id"></el-option>
          </el-select>
          <div @click="fullScreen" class="fullbtn">
<!--            <template v-if="isFullscreen">-->
<!--              <img src="@/assets/images/header/outfull.png" alt="">退出全屏-->
<!--            </template>-->
<!--            <template v-else>-->
<!--              <img src="@/assets/images/header/infull.png" alt="">全屏显示-->
<!--            </template>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapGetters, mapActions} from "vuex";
import Search from '@/components/common/search.vue'
import {storePersistKey} from "@/plugins/tools/Constant";
import {errorToast, successToast} from "@/plugins/tools/util";
import screenfull from "screenfull/dist/screenfull"

export default {
  props: [],
  watch: {
    $route: {
      immediate: true, // 一旦监听到路由的变化立即执行
      // 深度观察监听
      deep: true,
      handler(to, from) {
        console.log('to', to)
        const path = to.path
        this.headerBtn = path.split('/')[1]
      },
    }
  },
  components: {
     Search,
  },
  computed: {
    ...mapGetters({
      token: "userStore/token",
      userName: "userStore/userName",
      userId: "userStore/userId",
      current_site:'current_site',
      permissions: 'permissions'
    }),
  },
  mounted() {
    this.getNowTime()
    clearInterval(myTimeDisplay)
    var myTimeDisplay = setInterval(() => {
      this.getNowTime()
    }, 1000)
    this.init()
    // console.log('permissions',this.permissions)
    this.collegeList = this.permissions.gxfx
    this.currentCollege = this.current_site || {}
    if(this.$route.query && this.$route.query.collegeId){
      //query 入参id 指定高校
      this.collegeId = this.$route.query.collegeId
      if(this.currentCollege.id !== this.collegeId){
        this.currentCollege = this.collegeList.find(v => {
          return v.id === this.collegeId
        })
        this.$store.commit('SET_CURRENT_SITE',this.currentCollege)
        this.$router.push({path:'/college'})
      }
    }else{
      this.collegeId = this.currentCollege.id
    }
  },
  inject: ["reload", "msg"],
  data() {
    return {
      nowTimeDay: '',
      nowTimeSecond: '',
      headerBtn: '',//一级路由
      isFullscreen:false,
      currentCollege:{},
      collegeList:[],
      collegeId: ''
    }

  },
  destroy () {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.fullChange)
    }
  },
  created() {

  },
  methods: {
    setCurrentCollege(){
      this.currentCollege = this.collegeList.find(v => {
        return v.id === this.collegeId
      })
      this.$store.commit('SET_CURRENT_SITE',this.currentCollege)
      this.reload()
    },
    getNowTime() {
      var date = new Date()
      let days = ['一', '二', '三', '四', '五', '六', '日']
      var nowTimeDay = date.getFullYear() + '/' + this.addZero(date.getMonth() + 1) + '/'
        + this.addZero(date.getDate()) + ' 周' + (date.getDay()==0?'日':days[date.getDay() - 1])
      var nowTimeSecond = this.addZero(date.getHours()) + ':' + this.addZero(date.getMinutes()) + ':'
        + this.addZero(date.getSeconds())
      this.nowTimeDay = nowTimeDay
      this.nowTimeSecond = nowTimeSecond
    },
    addZero(s) {
      return s < 10 ? ('0' + s) : s
    },
    goto(path) {
      this.$router.push({
        path
      })
    },
    //退出登录
    logout() {
      this.$cookies.remove('token')
      localStorage.removeItem(storePersistKey)
      this.$store.dispatch('userStore/clearToken')
      successToast("退出登录成功")
      this.$router.push({path: '/'})
    },
    init() {
      if (screenfull.isEnabled) {
        screenfull.on('change', this.fullChange)
      }
    },
    fullChange () {
      console.log(1111111,screenfull.isFullscreen)
      this.isFullscreen = screenfull.isFullscreen
    },
    //切换
    fullScreen () {
      if (!screenfull.isEnabled) {
        return false
      }
      //全屏
      screenfull.toggle();
    },
  }
}

</script>

<style scoped lang="scss">
.h-bg {
  height: 112px;
  width: 100%;
  background: url(~@/assets/images/header/h-bg.png) center/cover;

  .header-box {
    @include flex(space-around);
    height: 80px;
    padding: 0 1%;

    .header-box-left,.header-box-right{
      width: 580px;
      @include flex(flex-start);
    }
    .btn-item {
      width: 120px;
      height: 34px;

      &.active {
        color: $mainColor-active;
        border-color: $mainColor-active;
        font-weight: bold;
        box-shadow: inset 0px 0px 10px 0px rgba(248, 197, 100, .7);
      }
    }

    .fullbtn {
      @include flex();
      color: #23E9FD;
      cursor: pointer;
      font-size: 16px;
      margin-left: 20px;

      img {
        height: 32px;
        width: 32px;
        margin-right: 8px
      }
    }

    .top-time {
      @include flex();
      color: #23E9FD;
      flex-shrink: 0;
      margin-right: auto;
    }
    .top-btn{
      margin: 0 8px;
    }
    .title {
      flex-shrink: 0;
      height: 40px;
      font-family: AliHeavy;
      color: rgba(0, 0, 0, 0.65);
      line-height: 40px;
      //text-shadow: 0px 0px 16px rgba(0, 150, 255, 0.7), 0px 2px 2px rgba(0, 0, 0, 0.8);
      background: linear-gradient(360deg, #008CDC 0%, #02FEFF 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}
/deep/ .el-input__inner {
    height: 34px;
    line-height: 34px;
  }

/deep/ .el-input__icon {
    height: 34px;
    line-height: 34px;
  }

</style>



// WEBPACK FOOTER //
// src/layoutCollege/components/header.vue